import React from 'react';
import { PlainPageHeadingContext } from 'components/plain_page_heading';
import { observer } from 'mobx-react';
import ContactForm from 'components/user/contact_form';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import HeaderBar from 'components/header_bar';
import Link from 'components/link';
import { AppUI } from '@seedlang/state';

const Wrapper = styled.div`
  width: 100%;
`;

const Content = styled.div`
  width: 100%;
  padding: ${props => props.embedded ? 0 : '10px 0 0 0'};
`;

const Panel = styled.div`
  background: white;
  border: ${props => props.embedded || props.isMobile ? 0 : '1px solid #dedede'};
  border-radius: ${props => props.embedded || props.isMobile ? 0 : '12px'};
  padding: ${props => props.embedded ? 0 : '24px'};
`;

const Heading = styled.h3`
  margin: 0 0 10px 0;
`;

const Paragraph = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 26px;
`;

const HelpCenterLink = styled.div`
  text-decoration: underline;
  margin-top: 12px;
`;

@observer
class Contact extends React.Component {
  static contextType = PlainPageHeadingContext;

  render() {
    return (
      <Wrapper>
        {
          !AppUI.layout.isMobile &&
            <HeaderBar
              title='Contact Us'
              titleRoute='contact'
              margin='0'
            />
        }
        <Content embedded={this.context}>
          <Panel
            embedded={this.context}
            isMobile={AppUI.layout.isMobile}
          >
            <Heading>
              We would love to hear from you.
            </Heading>

            <Paragraph>
              Whether it&apos;s a question or feedback, leave a message and we will get back to you as soon as we can.
            </Paragraph>
            <Link to='help_center'>
              <HelpCenterLink>
                You can also view our Help Center.
              </HelpCenterLink>
            </Link>
            <ContactForm
              {...this.props}
            />
          </Panel>
        </Content>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(Contact);
